import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

import { FuseConfigService } from '@fuse/services/config';

import { environment } from 'environments/environment';

import { ResponseRest } from 'app/interface/response-rest';
import { User } from './user';
import { Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class UserService {


    private url: string = environment.urlAuth + "/Account/";

    private _httpClient = inject(HttpClient);
    private _fuseConfigService = inject(FuseConfigService);

    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);


    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    current(): Observable<ResponseRest> {
        let url = `${this.url}Current/${environment.ApiKey}`;
        return this._httpClient
            .get<ResponseRest>(url)
            .pipe(
                map(res => {

                    if (res.Data?.Scheme !== null && res.Data?.Scheme !== '') {
                        const scheme = res.Data?.Scheme;
                        this._fuseConfigService.config = { scheme };
                    }

                    if (res.Data?.Layout !== null && res.Data?.Layout !== '') {
                        const layout = res.Data?.Layout;
                        this._fuseConfigService.config = { layout };
                    }

                    this._user.next(res.Data);


                    return res;
                })
            );
    }

    update(domain: User) {
        let body = JSON.stringify(domain);
        let url = `${this.url}Create`;
        return this._httpClient
            .post(url, body)
            .pipe(
                map(res => {
                    return res;
                }));
    }


    updateScheme(domain: User) {
        let body = JSON.stringify(domain);
        let url = `${this.url}Scheme/${environment.ApiKey}`;
        return this._httpClient
            .post(url, body)
            .pipe(
                map(res => {
                    return res;
                }));
    }


    updateLayout(domain: User) {
        let body = JSON.stringify(domain);
        let url = `${this.url}Layout/${environment.ApiKey}`;
        return this._httpClient
            .post(url, body)
            .pipe(
                map(res => {
                    return res;
                }));
    }


}
